module.exports = {
  "level1": {
    name: "الاسم الحقيقي",
    idcard: "نوع الشهادة",
    address: "عنوان الإقامة الحالي" ,
    "bank_number": "عدد البنوك",
    wc: "حسنًا",
    "name_nodata": "لا يمكن أن يكون الاسم فارغًا" ,
    "id_card_nodata": "لا يمكن أن يكون رقم الشهادة فارغًا" ,
    "address_nodata": "لا يمكن أن يكون العنوان فارغًا" ,
    "bank_number_nodata": "رقم البطاقة المصرفية لا يمكن أن يكون فارغًا" ,
    "input-username": "الرجاء إدخال اسمك الحقيقي" ,
    zjhm: "رقم الشهادة",
    "input-idcard": "الرجاء إدخال رقم شهادتك" ,
    "input-address": "الرجاء إدخال عنوانك" ,
    zjlx: "أنواع المعرفات الصالحة",
    qxzzjlx: "الرجاء تحديد أنواع معرف صالح" ,
    sfz: "بطاقة الهوية" ,
    hz: "Passport",
    jsz: "رخصة القيادة" ,
    lxz: "شهادة الدراسة بالخارج",
    zfbzh: "حساب Alipay" ,
    qsrzfbzh: "الرجاء إدخال حساب alipay الخاص بك" ,
    khh: "فتح حساب",
    qsrkhh: "الرجاء إدخال بنك حسابك",
    yhkh: "رقم البطاقة المصرفية" ,
    qsryhkh: "الرجاء إدخال رقم بطاقتك المصرفية",
    zfzh: "حساب الدفع" ,
    qxzzfzh: "الرجاء اختيار حساب دفع" ,
    gjlb: "قائمة البلدان",
    qxzgjlb: "الرجاء تحديد البلد / المنطقة"
    },
    my:{
      bindphone: "ربط الهاتف",
      gqrcode: "امسح الشفرة ثنائية الأبعاد التالية أو أدخل الرمز الترويجي , وأكد التسجيل" ,
      mqrcode: "Qrcode الخاص بي",
      as: "إعدادات",
      pc: "شهادة المبتدئين" ,
      ac: "شهادة عليا" ,
      smrz: "شهادة",
      sfyz: "مصادقة KYC" ,
      mm: "أصولي" ,
      ms: "مشاركة",
      me: "أرباحي",
      zsr: "إجمالي الإيرادات",
      mp: "ترقيتي" ,
      yqhy: "دعوة الأصدقاء" ,
      ar: "السجلات" ,
      hc: "مساعدة",
      nodata: "لا توجد بيانات",
      med: "خطوط أرباحي",
      aes: "جميع الأرباح (USDT)",
      one: "واحد",
      two: "اثنان",
      three: "ثلاثة",
      four: "أربعة",
      ones: "رقم واحد" ,
      twos: "رقمان" ,
      threes: "ثلاثة عدد" ,
      fours: "أربعة عدد" ,
      promotion: "إجمالي",
      customers: "أرباحي",
      total: "total",
      usdt: "USDT",
      wdzc: "أصولي",
      wdzc1: "أصولي",
      wyfx: "مشاركاتي",
      wdsy: "أرباحي",
      wdtg: "ترقيتي" ,
      zhjl: "السجلات",
      fbjl: "سجلات معاملات OTC" ,
      zxkf: "خدمة عبر الإنترنت" ,
      wdxx: "رسالتي"
    },
    "footer": {
      home: "المنزل",
      quotation: "الأسواق" ,
      currency: "العملات",
      lever: "العقود" ,
      assets: "أرصدة" ,
      "my": "حسابات",
      lc: "ربح USDT"
    } ,
    "index": {
      wdzc: "أصولي",
      xsbk: "دليل المبتدئين",
      dlhkck: "العرض بعد تسجيل الدخول",
      dl: "العرض بعد تسجيل الدخول",
      zxkf: "اتصل بنا" ,
      "function": "الخدمات",
      "legal": "فيات" ,
      legaltxt: "شراء الأصول الرقمية بأموال ورقية" ,
      levertxt: "استثمار يساوي عدة أضعاف مبلغ صندوقك الأصلي" ,
      c2c: "c2c",
      c2ctxt: "تجارة ثنائية للتحوط" ,
      increase: "أفضل الرابحين",
      innovate: "Top Innovate" ,
      myshop: "متجري",
      order: "إدارة الطلبات" ,
      myc2c: "c2c التي أتداولها" ,
      usercenter: "Personal Center" ,
      myshare: "رابط المشاركة الخاص بي",
      releasec2c: "release c2c",
      language: "اللغة",
      security: "مركز الأمان" ,
      pay: "طريقة الدفع",
      bindaddress: "ربط عنوان السحب",
      address: "عنوان الانسحاب" ,
      aboutus: "نبذة عنا",
      logout: "تسجيل الخروج" ,
      vol: "24H Vol",
      jc: "JC exchange BEAU" ,
      kjcb: "إيداع سريع",
      zcbz: "BTC, USDT ..."
    } ,
    "transaction": {
      buy: "اشتر",
      sell: "بيع" ,
      pwd: "كلمة مرور المعاملة" ,
      inputpass: "كلمة المرور" ,
      inputnum: "Amount",
      Limit: "Limit",
      avaiable: "متاح",
      turnover: "دوران",
      handicap: "الإعاقة" ,
      number: "الكمية",
      nonumber: "كمية غير مكتملة" ,
      numbered: "الكمية المكتملة" ,
      price: "السعر",
      marketprice: "السوق",
      cancel: "إلغاء" ,
      total: "تداول شامل" ,
      time: "التوقيت" ,
      "nomore": "لا أكثر",
      nodata: "لا يوجد سجل",
      getmore: "تحميل المزيد",
      mycommission: "الطلبات",
      currentbuy: "Current (Buy)" ,
      curentsell: "Current (Sell)",
      his: "التاريخ (مكتمل)" ,
      currency: "العملات",
      option: "العملية" ,
      wtime: "وقت الإكمال",
      wnumber: "الكمية المكتملة" ,
      wprice: "سعر الإكمال"
    },
    mk: {
      high: "H" ,
      low: "L",
      vol: "24H",
      newPrice: "آخر سعر",
      product: "المنتج",
      name: "اسم",
      rank: "قائمة المكاسب"
    } ,
    "deals": {
    issue_time: "الوقت",
    issue_number: "Number",
    white_book: "كتاب",
    weburl: "Url",
    video_url: "فيديو",
    introduction: "معلومات" ,
    onhand: "يد واحدة متساوية" ,
    position: "موضع",
    leverorder: "أوامر الرافعة المالية",
    leverposition: "المنصب الرفع" ,
    inputprice: "سعر الإدخال" ,
    inputmul: "الإدخال المتعدد" ,
    selectmul: "اختيار متعدد" ,
    onehand: "يد واحدة تساوي" ,
    hand: "عدد الأيدي التجارية" ,
    marketval: "قيمة السوق" ,
    bond: "Bond",
    service: "رسوم الخدمة" ,
    balance: "Balance",
    type: "النوع" ,
    risk: "معدل المخاطرة" ,
    total: "إجمالي الربح",
    onekey: "إغلاق" ,
    makemore: "(طويل)" ,
    makeless: "(قصير)",
    current: "Open Orders",
    all: "الكل",
    Weing: "في العمولة" ,
    tding: "تجارة",
    ping: "إغلاق",
    pied: "مغلق",
    ceiled: "مسحوبة" ,
    weprice: "سعر العمولة",
    oprice: "سعر الافتتاح",
    nowprice: "السعر الحالي",
    zyprice: "إيقاف سعر الأرباح" ,
    zsprice: "سعر وقف الخسارة",
    canbond: "الهامش المتاح",
    pptie: "وقت الافتتاح",
    pgtime: "وقت الإغلاق",
    znum: "الكمية المحولة" ,
    gprice: "رسوم الليلة",
    pcang: "إغلاق",
    revoke: "سحب" ,
    fee: "رسوم" ,
    you: "سعر السوق الأمثل"
    } ,
    "assets": {
    bzxz: "اختيار العملة",
    copy: "نسخ",
    currency: "العملة",
    lever: "الهامش" ,
    legal: "العملة الفرنسية" ,
    curAccount: "حساب معاملة" ,
    total: "معادلة الأصول (USDT)" ,
    leverAccount: "حساب الرافعة المالية",
    legalAccount: "French account",
    avaiable: "متاح",
    lock: "تجميد" ,
    conversion: "تحويل" ,
    exact: "حساب معاملة" ,
    transfer: "نقل" ,
    num: "الكمية",
    time: "وقت",
    record: "سجل" ,
    caidata: "السجل المالي" ,
    from: "من",
    to: "إلى",
    transnum: "عدد عمليات النقل" ,
    all: "الكل",
    canuse: "متاح" ,
    pmin: "الرجاء إدخال الحد الأدنى لعدد التحويلات" ,
    cmoney: "إيداع",
    tmoney: "سحب" ,
    caddress: "عنوان الشحن",
    copyaddress: "نسخ العنوان" ,
    a01: "لا تشحن أي شيء غير",
    a02: "أصول للعنوان أعلاه ，",
    a03: "وإلا فلن يتم استرداد الأصول.",
    a04: "الشحن يدعم فقط طريقة الإرسال البسيطة. الشحن بالطرق الأخرى غير متاح مؤقتًا. يرجى فهم ذلك.",
    a05: "بعد إعادة الشحن إلى العنوان أعلاه , تحتاج إلى تأكيد عقدة الشبكة بالكامل , وتأكيد شبكة واحد وستة شبكات يمكن أن تسحب الأموال.",
    a06: "الحد الأدنى لمبلغ إعادة الشحن:",
    a07: "لن يتم تسجيل إعادة الشحن التي تقل عن الحد الأدنى ولا يمكن إرجاعها.",
    a08: "عنوان التزويد الخاص بك لن يتغير كثيرًا , يمكنك تجديده ؛ إذا كان هناك أي تغيير , فسنحاول إخطارك من خلال نشرة الشبكة أو البريد." ,
    a09: "تأكد من أن الكمبيوتر والمتصفح آمنان لمنع العبث بالمعلومات أو تسريبها.",
    taddress: "عنوان السحب" ,
    taddressm: "الرجاء إدخال عنوان سحب العملة" ,
    padd: "أدخل أو اضغط مع الاستمرار على العنوان" ,
    rate: "رسوم المناولة",
    dnum: "وصل عدد الحسابات" ,
    more: "تحميل المزيد",
    nodata: "لا يوجد سجل حتى الآن",
    search: "بحث العملة" ,
    yczc: "إخفاء الأصول التي لا تملكها"
    } ,
    td: {
      drecord: "سجل الطلبات" ,
      orecord: "الطلبات المكتملة",
      filter: "تصفية",
      tdtype: "نوع المعاملة" ,
      buy:"اشتر",
      sell: "بيع" ,
      wantbuy: "شراء" ,
      dstatus: "حالة الطلب",
      nofinish: "لم تنته",
      finished: "مكتملة",
      ceiled: "ملغى",
      payed: "Paymented",
      waitPay: "يتم الدفع",
      reset: "إعادة تعيين" ,
      confirm: "تأكيد" ,
      time: "وقت",
      num: "الرقم" ,
      tdtotal: "المبلغ",
      call: "الاتصال ببعضنا البعض" ,
      buyer: "المشتري" ,
      seller: "البائع" ,
      Sprice: "سعر الوحدة",
      price: "السعر",
      ptime: "وقت الطلب",
      cnum: "الرقم المرجعي",
      tdceil: "إلغاء التداول" ,
      sureReceive: "تأكيد المستحقات" ,
      conPay: "تأكيد الدفع" ,
      ppay: "الرجاء الدفع",
      paynext: "الرجاء الدفع للحساب التالي" ,
      tdPrice: "سعر الوحدة",
      tdNum: "الرقم",
      payInfo: "معلومات الدفع" ,
      accountInfo: "معلومات الحساب" ,
      receiver: "المستفيد" ,
      open: "فتح البنك" ,
      pcnum: "عند إجراء الدفع , يرجى ملء الرقم المرجعي" ,
      imPay: "لقد دفعت" ,
      tdAttion: "تذكير",
      odCeil: "إلغاء الطلبات",
      at01: "ستذهب حوالتك المالية مباشرة إلى حساب البائع , وستتم حماية الأصول الرقمية التي يبيعها البائع أثناء المعاملة من خلال عهدة المنصة.",
      at02: 'يرجى إكمال السداد في غضون الوقت المحدد , وتأكد من النقر فوق" لقد دفعت ". بعد أن يؤكد البائع الإيصال , سيقوم النظام بنقل الأصول الرقمية إلى حسابك.',
      at03: 'إذا ألغى المشتري الطلب ثلاث مرات في نفس اليوم , فسيقتصر على وظيفة الشراء في ذلك اليوم.',
      sureImpay: "الرجاء تأكيد أنك دفعت للبائع.",
      badClick: "النقرات الضارة ستجمد الحسابات مباشرة.",
      notpay: "لم أدفع للطرف الآخر بعد.",
      sureDpay: "الرجاء تأكيد أن المشتري قد دفع لك.",
      sureCeil: "تأكيد إلغاء المعاملات",
      notCeil: "إذا كنت قد دفعت للبائع , فالرجاء عدم إلغاء المعاملة.",
      dover: "تم إكمال الطلب ولا يمكن الاطلاع على معلومات الدفع" ,
      cover: "تم إلغاء الطلب ولا يمكن عرض معلومات الدفع" ,
      payFast: "الرجاء الدفع للبائع بمجرد تأكيد الدفع" ,
      payClick: 'إذا قمت بتحويل دفعة إلى البائع ، فيرجى التأكد من النقر فوق الزر "لقد دفعت" في الزاوية اليمنى السفلية ، وإلا فقد يتسبب ذلك في خسائر مالية.',
      pwait: "برجاء انتظار المشتري للدفع.",
      pwd: "كلمة مرور التداول" ,
      ppwd: "كلمة مرور المعاملة",
      "sure": "بالتأكيد",
      alipay: "أليباي" ,
      wechat: "Wechat",
      bank: "بطاقة مصرفية" ,
      realName: "الاسم الحقيقي" ,
      knum: "رقم البطاقة",
      pprice: "سعر الوحدة",
      pnum: "الكمية" ,
      min: "الحد الأدنى لحجم التداول" ,
      pmin: "الحد الأدنى لحجم المعاملات" ,
      max: "الحد الأقصى لحجم التداول" ,
      pmax: "الحد الأقصى لحجم المعاملات",
      buyNum: "شراء الكمية" ,
      currency: "العملة",
      pmethod: "طريقة الدفع",
      choose: "الرجاء الاختيار" ,
      mysells: "بيعي" ,
      mybuys: "مشترياتي" ,
      pcoin: "وحدة نقدية"
    } ,
    "fat": {
      mybuy: "أريد الشراء" ,
      mysell: "أريد البيع" ,
      ceil: "إلغاء" ,
      buy: "اشتر" ,
      forsell: "بيع" ,
      forbuy: "شراء" ,
      sell: "بيع" ,
      price: "سعر الوحدة",
      bprice: "شراء بسعر" ,
      bnum: "الشراء بالكمية" ,
      pbtotal: "المبلغ الإجمالي للعملة الفرنسية التي تريد شراءها" ,
      pstotal: "المبلغ الإجمالي للعملة الفرنسية التي تريد بيعها" ,
      pbnum: "الكمية التي تريد شراءها" ,
      psnum: "الكمية التي تريد بيعها" ,
      allbuy: "كل الشراء" ,
      allsell: "all sell",
      Limit: "Limit",
      tdtotal: "المبلغ",
      autoceil: "يلغي تلقائيًا" ,
      num: "الرقم" ,
      submit: "تقديم طلب" ,
      pwd: "كلمة مرور التداول" ,
      ppwd: "كلمة مرور التداول",
      sure: "تأكيد الطلب" ,
      reTime: "العمل المعتمد | وقت التسجيل" ,
      release: "سراح" ,
      allOrder: "أمر التجميع",
      dayOrder: "طلب 30 يومًا" ,
      overOrder: "أمر الإكمال" ,
      rate: "معدل الإكمال",
      auPhone: "Mobile",
      auName: "الاسم الحقيقي" ,
      auHigh: "متقدم",
      sellLine: "البيع عبر الإنترنت" ,
      buyLine: "الشراء عبر الإنترنت" ,
      myshop: "متجري",
      mybalance: "رصيد التاجر"
    } ,
    "auth": {
      bh: "مرفوض",
      bhr: "تم رفض طلبك للأسباب التالية:",
      mycenter: "مركز شخصي" ,
      test: "المصادقة",
      gotest: "للمصادقة" ,
      testing: "قيد المراجعة" ,
      tested: "معتمد",
      t1: "بعد التصديق , يمكن زيادة مبلغ السحب.",
      t2: "يمكن إجراء معاملات c2c بعد التصديق.",
      t3: "بعد التصديق , يمكن إجراء المعاملات القانونية بالعملة" ,
      name: "اسم",
      account: "الحساب" ,
      number: "رقم الشهادة" ,
      pname: "اسمك" ,
      pnum: "رقم الهوية" ,
      id_card_face: "الرجاء تحميل مقدمة بطاقة الهوية" ,
      id_card_back: "الرجاء تحميل ظهر بطاقة الهوية" ,
      upimg: "الرجاء تحميل الوجهين الأمامي والخلفي للشهادة , وكذلك الصور الأمامية مع الشهادة في متناول اليد.",
      updata: "إرسال" ,
      updata_again: "إرسال مرة أخرى"
    } ,
    "code": {
    mycode: "رمز الترويج الخاص بي",
    code: "الرمز الترويجي" ,
    qrcode: "امسح نمط الشفرة ثنائي الأبعاد أعلاه أو أدخل رمز الترويج لتأكيد التسجيل" ,
    notice: "إشعار" ,
    about: "أخبار ذات صلة"
    } ,
    "safe": {
      title: "أمان الحساب" ,
      center: "مركز الأمن",
      qchc: "مسح ذاكرة التخزين المؤقت",
      yysz: "اللغة",
      ssms: "الوضع الداكن",
      gywm: "نبذة عنا",
      lgpwd: "كلمة مرور تسجيل الدخول" ,
      tkmm: "سحب كلمة المرور",
      paypwd: "كلمة مرور الدفع",
      resetpwd: "تعديل كلمة المرور",
      paccount: "رقم هاتفك الخلوي أو صندوق بريدك" ,
      next: "الخطوة التالية",
      reset: "تعديل" ,
      stest: "التحقق الأمني",
      ceil: "إلغاء" ,
      pcode: "رمز التحقق",
      send: "احصل على CAPTCHA" ,
      sure: "تأكيد" ,
      newPwd: "إعادة تعيين كلمة المرور",
      len: "كلمة المرور تحتاج من 6 إلى 20 حرفًا",
      ppwd: "كلمة المرور",
      reppwd: "كلمة المرور مرة أخرى.",
      repwd: "إعادة تعيين كلمة المرور",
      zpwd: "كلمة مرور المعاملة"
    } ,
    "met": {
      add: "Add way",
      "open": "اسم البنك الافتتاحي" ,
      bank: "الحساب المصرفي" ,
      realname: "الاسم الحقيقي" ,
      alipay: "حساب Alipay",
      wename: "لقب Wechat" ,
      wechat: "حساب Wechat",
      save: "حفظ" ,
      popen: "اسم البنك الافتتاحي" ,
      pbank: "رقم حساب البنك الافتتاحي",
      pname: "الاسم الحقيقي" ,
      palipay: "حساب Alipay",
      pwename: "لقب Weixin" ,
      pweaccount: "حساب Wechat"
    } ,
    "ads": {
      tas: "عنوان التذكرة",
      "address": "عنوان",
      noads: "ليس لديك عنوان بعد.",
      adds: "العنوان" ,
      padd: "عنوان السحب أو اللصق" ,
      remark: "ملاحظة" ,
      cel: "حذف"
    } ,
    "call": {
      callme: "اتصل بنا" ,
      privacy: "نهج الخصوصية"
    } ,
    jc: {
      title: "JC Conversion BEAU" ,
      bind: "ربط الحسابات" ,
      balance: "JC Balance",
      cannum: "كمية JC المتوفرة:" ,
      new: "أحدث سعر BEAU:" ,
      exnum: "الكمية التبادلية:",
      pnum: "كمية JC" ,
      canex: "تحويل BEAU الكمية: ≈",
      exnow: "الصرف الفوري" ,
      record: "سجل Exchange" ,
      exprice: "سعر الصرف:",
      extime: "وقت الصرف" ,
      not: "عدد التكاملات المتوفرة غير كافٍ" ,
      usenum: "Use JC Quantity",
      paccount: "رقم الحساب" ,
      ppwd: "كلمة المرور",
      gotd: "معاملة"
    } ,
    lg: {
      welcome: "مرحبًا! الرجاء تسجيل الدخول" ,
      hsa: "هل لديك حساب؟",
      lgs: "تسجيل الدخول" ,
      lgbt: "تسجيل الدخول",
      lgtel: "تسجيل الدخول عبر الهاتف المحمول",
      lgeml: "تسجيل الدخول عبر البريد الإلكتروني" ,
      paccount: "رقم الهاتف أو البريد الإلكتروني" ,
      ppwd: "الرجاء إدخال كلمة المرور الخاصة بك",
      ppwd2: "الرجاء تأكيد كلمة المرور الخاصة بك",
      qsryqm: "رمز الدعوة",
      pcode: "رمز التحقق",
      mepwd: "تذكر كلمات المرور",
      noaccount: "ليس لديك حساب بعد؟",
      qregister: "تسجيل" ,
      register: "تسجيل" ,
      phregister: "التسجيل عبر الهاتف" ,
      emregister: "التسجيل عن طريق البريد الإلكتروني" ,
      noset: "لا يمكن تعديلها بعد التسجيل" ,
      pphone: "رقم الهاتف المحمول",
      next: "الخطوة التالية",
      have: "هل يوجد حساب؟" ,
      ceil: "إلغاء" ,
      msgtest: "التحقق من الرسائل القصيرة",
      send: "احصل على CAPTCHA" ,
      sure: "موافق",
      email: "عنوان البريد الإلكتروني" ,
      emtest: "التحقق من صحة علبة البريد" ,
      scode: "إرسال رمز المصادقة" ,
      pemcode: "رمز التحقق",
      ppcode: "رمز التحقق",
      ftpwd: "هل نسيت كلمة المرور؟",
      ftpwds: "نسيت كلمات المرور",
      ptext: "رقم الهاتف المحمول أو صندوق البريد" ,
      safetest: "التحقق الأمني",
      sjh: "رقم الهاتف الخلوي" ,
      yzm: "رمز التحقق" ,
      mm: "كلمة المرور",
      qrmm: "تأكيد كلمة المرور" ,
      mmcd: "طول كلمة المرور 8-12 بت",
      language: "اللغة",
      kjzc: "اتصل بنا للتسجيل السريع" ,
      kjzc1: "لا يمكن تلقي اختبار CAPTCHA؟",
      kjzc2: "تسجيل سريع",
      wyzx: "أعرف بالفعل" ,
      qtxyxzh: "هام: الرجاء إدخال عنوان بريد إلكتروني صالح أو رقم هاتف محمول , والذي يمكن استخدامه لاسترداد كلمة المرور الخاصة بك"
    } ,
    gjrz: {
      title: "شهادة عليا" ,
      t1: "الصور التي يقل حجمها عن 8 ميغابايت وبتنسيقات JPG أو JPEG أو PNG مدعومة.",
      t2: "يجب أن تكون صور مستند الهوية واضحة ولا يجوز تعديلها أو حظرها. يجب أن تكون الصورة الشخصية ورقم المستند واسم صاحب المستند مرئية بوضوح.",
      t3: "يجب التقاط الصور بدون أي غطاء للرأس , ويوصى بعدم استخدام المكياج. يجب أن تكون ملامح وجه حامل المستندات واضحة ويمكن التعرف عليها , ويجب أن تكون أذرعهم مكشوفة بالكامل.",
      t4: "موافق",
      bh: "رفض",
      shz: "قيد المراجعة",
      shtg: "موافق عليه" ,
      nyrzcg: "لقد تم اعتمادك بنجاح" ,
      sczjz: "تحميل صور الهوية",
      sczjzmz: "تحميل صورة أمام وثيقة الهوية",
      sczjbmz: "تحميل صورة ظهر وثيقة الهوية",
      scgrqmz: "تحميل المستندات والتوقيع الشخصي"
    } ,
    chongzhi: {
      title: "الإيداع" ,
    cbjl: "سجل الإيداع" ,
    t1: "الكمية",
    t2: "الرجاء إدخال الكمية",
    t3: "وصف القسيمة (اختياري)",
    t4: "الرجاء إدخال الوصف",
    t5: "صورة قسيمة",
    t6: "حسنًا",
    t7: "اسم السلسلة",
    t8: "رمز الاستجابة السريعة",
    t9: "حفظ رمز الاستجابة السريعة",
    t10: "عنوان الشحن",
    t11: "نسخ",
    zy: "هام" ,
    tips1: "يُرجى عدم شحن أي أصول ليست بهذه العملة إلى العنوان أعلاه وإلا لا يمكن استرداد الأصول" ,
    tips2: "توافق المحفظة / النظام الأساسي: أي دعم الشبكة ؛ إذا كان النظام الأساسي المستهدف لا يدعم شبكة السحب الخاصة بك ، فلن يتم استرداد الأصول.",
    tips3: "شبكة التعبئة والنظام الأساسي المستهدف متماثلان ؛ إذا اخترت العنوان المستهدف هو شبكة Ethereum , لكن إعادة التعبئة تختار السلسلة الذكية TRC20 , فقد لا تتمكن من استرداد الأصول الرقمية. ",
    tips4: "تأكد من صحة عنوانك والمبلغ قبل إعادة الشحن.",
    tips5: "تذكير: نظرًا لإخفاء الهوية وخصوصية شبكة الحظر , بمجرد إدخال المعلومات الخاطئة , ستفقد الأصول المقابلة. يرجى التحقق من عنوان وكمية إعادة الشحن بعناية"
    } ,
    tibi: {
      title: "سحب" ,
      tbjl: "سجل السحب" ,
      t1: "عنوان السحب",
      t2: "الرجاء إدخال عنوان السحب",
      t3: "كمية السحب" ,
      qsrtbsl: "الرجاء إدخال كمية عملة السحب" ,
      t4: "الحد الأدنى",
      t5: "كلمة مرور المعاملة",
      t6: "الرجاء إدخال كلمة مرور المعاملة" ,
      t7: "الرسوم",
      t8: "الكمية المحولة إلى الحساب" ,
      t9: "حسنًا",
      sc: "حذف" ,
      bj: "تحرير",
      bq: "علامة (مذكرة)" ,
      qsrbq: "الرجاء إدخال العلامة",
      yhktx: "سحب البطاقة المصرفية",
      yhmc: "Bank Name",
      qsryhmc: "الرجاء إدخال اسم البنك",
      yhzh: "حساب مصرفي" ,
      qsryhzh: "الرجاء إدخال الحساب المصرفي" ,
      gjhkdm: "رمز SWIFT" ,
      qsrgjhkdm: "الرجاء إدخال رمز SWIFT" ,
      yhdz: "عنوان البنك",
      qsryhdz: "الرجاء إدخال عنوان البنك",
      skrxm: "اسم المدفوع لأمره",
      qsrskrxm: "الرجاء إدخال اسم المدفوع لأمره" ,
      skrdh: "هاتف المدفوع لأمره",
      qsrskrdh: "الرجاء إدخال هاتف المدفوع لأمره" ,
      skrdz: "عنوان المدفوع لأمره",
      qsrskrdz: "الرجاء إدخال عنوان المدفوع لأمره"
    } ,
    huazhuan: {
      title: "تحويل USDT" ,
      t1: "رصيد حساب الصرف",
      t2: "رصيد حساب الهامش",
      t3: "كمية التحويل",
      t4: "الرجاء إدخال الكمية",
      t5: "اتجاه النقل",
      t6: "من",
      t7: "حساب Exchange",
      t8: "إلى",
      t9: "حساب الهامش",
      t10: "حسنًا",
      zf: "الدفع" ,
      ky: "متاح" ,
      dd: "Get",
      qbdh: "تبادل الكل" ,
    } ,
    "banner": {
      title: "التفاصيل"
    } ,
    "download":{
      t1: "تداول في أي وقت وفي أي مكان",
      xz: "تنزيل"
    } ,
    xgdlmm: {
      title: "تعديل كلمة مرور تسجيل الدخول" ,
      zh: "الحساب" ,
      zhts: "رقم الهاتف المحمول أو البريد الإلكتروني" ,
      yzm: "رمز التحقق",
      yzmts: "رمز التحقق",
      hqyzm: "احصل على CAPTCHA",
      mm: "كلمة المرور",
      mmts: "طول كلمة المرور 6-12 حرفًا",
      qrmm: "تأكيد كلمة المرور" ,
      send: "احصل على CAPTCHA" ,
      qr: "موافق"
    } ,
    sztkmm: {
      title: "تعيين كلمة مرور السحب" ,
      dlmm: "كلمة مرور تسجيل الدخول" ,
      dlmmts: "الرجاء إدخال كلمة مرور تسجيل الدخول" ,
      xmm: "كلمة مرور جديدة",
      mmts: "طول كلمة المرور 6 أرقام",
      qrmm: "تأكيد كلمة المرور" ,
      qr: "موافق",
      qd: "موافق",
      sztkts: "نصيحة: الرجاء الانتقال إلى مركز الأمان لتعيين كلمة مرور المعاملة"
    } ,
    "rule":{
      title: "قواعد الحدث",
      title2: "القواعد",
      title3: "نشاط"
    } ,
    "news":{
      title: "رسالتي",
      ckxq: "عرض التفاصيل",
      gg: "إشعار"
    } ,
    xsbk: {
      title: "دليل المبتدئين"
    } ,
    search:{
      qx: "إلغاء",
      rmss: "بحث سريع" ,
      ss: "بحث"
    } ,
    wdtg: {
      title: "دعوة أفضل صديق لك" ,
      yq: "انضم إليك بالعمولة",
      zyj: "",
      wdyqlj: "رابط دعوتي",
      wdyqm: "رمز دعوتي" ,
      schbyq: "إنشاء دعوة ملصق" ,
      ljtgsy: "إجمالي الإيرادات",
      ljkh: "إجمالي المستخدمين (الأشخاص)" ,
      tkrs: "عدد الدعوات",
      ljyj: "العمولة التراكمية",
      yjmx: "تفاصيل العمولة",
      ljyjjl: "جوائز العمولة التراكمية (USDT" ,
      ljsy: "إجمالي الإيرادات",
      ljyqjl: "جوائز الدعوة التراكمية (USTD)" ,
      fxd: "مشاركة على",
      wxhy: "أصدقاء WeChat",
      wxpyq: "لحظات WeChat",
      bctp: "حفظ الصور",
      qx: "إلغاء",
      t1: "يمكنك جني جميع الأرباح" ,
      t2: "من تقليب العملة",
      t3: "تحديد الصورة أو احتيالها"
    } ,
    bzhl: {
      title: "كسب النقودAI",
      gz: "القواعد",
      tgdd: "طلب الضمان",
      zztgdzj: "الأموال المحتجزة" ,
      yjjrsy: "تقديري يوميًا",
      ljsy: "إجمالي الإيرادات",
      tgzdd: "أمر في الحجز",
      cljxcp: "منتجات الحملة الإستراتيجية",
      dbxe: "حد واحد",
      rsyl: "معدل العائد اليومي",
      zq: "دورة",
      qmr: "اذهب واشتري" ,
      bbzhzc: "أصول الحساب",
      zcc: "总 资产 (USDT)" ,
      dd: "الطلبات",
      buy: "شراء في" ,
      jxcp: "المنتجات المميزة",
      ckdd: "فحص الطلب",
      gd: "more",
      xzbzts: "بسيطة وآمنة. يمكن تحديد أرباح الأسهم بعملات متعددة",
      qtbz: "عملات معدنية أخرى"
    } ,
    bzhlgm: {
      title: "الأرباح من إزالة الطوب" ,
      bzhld: "أرباح إزالة الطوب USDT" ,
      qtzq: "دورة USDT لمدة 7 أيام" ,
      rsyl: "الجرذ العائد اليومي",
      lczq: "الدورة المالية",
      dbxe: "حصة تحويل واحدة (USDT)",
      pxsj: "وقت توزيع الأرباح",
      mr: "يوميًا",
      dqfh: "العودة عند الاستحقاق",
      tgzj: "عاصمة الحراسة",
      tqsh: "استرداد مبكر",
      yjsy: "الدخل المتوقع (USDT)" ,
      kyzc: "الأصول المتاحة (USDT)",
      cpjs: "حول منتجاتنا",
      tgje: "مبلغ الحفظ",
      qsrtgje: "الرجاء إدخال مبلغ الوصاية" ,
      qb: "الكل",
      rm: "اشترِ الآن",
      cpzq: "دورة المنتج",
      jxr: "計 息 日",
      jiexr: "結 息 日",
      yjdzr: "預計 到賬 日",
      gz: "اعرف القواعد والاهتمامات"
    } ,
    bzhlwdtg: {
      title: "حالة الطلب" ,
      tgz: "قيد الحجز",
      ywc: "مكتمل",
      ysh: "تم الاسترداد",
      tgje: "مبلغ الحفظ / مدة الحفظ",
      rsyl: "الجرذ العائد اليومي",
      yhl: "مكسب",
      xdsj: "وقت الطلب",
      sh: "الفداء" ,
      ddxq: "تفاصيل الطلب",
      ddh: "رقم الطلب"
    } ,
    bzjj: {
      t1: "اربح كل يوم",
      t2: "إزالة الطوب هي عملية تنقل USDT إلى المنصة , وتتمتع فرق المنصة المحترفة بسلطة نقل الطوب. يمكن للمشاركين مشاركة جزء من دخل إزالة الطوب الخاص بالمنصة خلال فترة حضانة رأس المال.",
      cpld: "مميزات المنتج",
      scsq: "إيداع وخذ في أي وقت",
      pxzq: "دورة توزيع الأرباح",
      mtxf: "التوزيع يوميًا",
      hqlx: "الفائدة الحالية",
      zj: "100٪ Fund",
      aqbz: "الأمان",
      jjrsy: "أرباح الأعياد",
      sybjd: "الربح المستمر" ,
      bjd: "غير متقطع",
      cgcrh: "بعد الإيداع الناجح",
      dtqx: "قيمة الفائدة في اليوم",
      jglz: "على سبيل المثال" ,
      syjs: "حساب الإيرادات" ,
      cont1: "إذا قام أحد الأعضاء بإيداع 10,000 U على المنصة وقام باختيار المنتجات المالية بدورة استحقاق مدتها سبعة أيام ومعدل عائد يومي يتراوح من 0.3 إلى 0.5٪ , فإن العائد اليومي يكون كما يلي:",
      cont2: "الحد الأدنى: 10000 U * 0.3٪ = 30U",
      cont3: "الحد الأقصى: 10000 وحدة * 0.5٪ = 50 وحدة",
      cont4: 'أي , بعد 7 أيام , يمكنك الحصول على 210-350 U من الدخل. سيتم توزيع هذا الدخل يوميًا , ويمكن الوصول إلى الدخل الموزع في أي وقت. سيعود رأس المال تلقائيًا إلى حساب محفظتك بعد انتهاء الصلاحية من الفترة. ',
      gywyj: "حول التعويضات المقطوعة",
      cont5: "إذا كنت تريد تحويل أصل المبلغ غير المستحق , فستخضع لتعويضات مقطوعة , والتي تساوي نسبة التسوية الافتراضية , مضروبة في الأيام المتبقية , مضروبة في كمية الاستثمار" ,
      cont6: "على سبيل المثال: إذا كانت نسبة التسوية الافتراضية للمنتج هي 0.4٪ , وتستحق الاستحقاق خلال 3 أيام , بكمية استثمار 1000 , فإن التعويضات المقطوعة = 0.4٪ * 3 * 1000 = 12 وحدة , وسيكون رأس المال المرتجع الفعلي 1000 U-12 U = 988 U ",
      wycy: "أريد الانضمام"
    } ,
    zyzs: {
      title: "جني الأرباح ووقف الخسارة",
      zy: "جني الأرباح" ,
      zs: "وقف الخسارة",
      qsrzyjg: "الرجاء إدخال سعر جني الأرباح" ,
      qsrzsjg: "الرجاء إدخال سعر إيقاف الخسارة" ,
      cfjglx: "نوع سعر التشغيل:" ,
      zsjg: "سعر المؤشر",
      scjg: "سعر السوق",
      pcfs: "طرق إغلاق المراكز:",
      kpcw: "Closeout",
      qbcw: "جميع المواضع",
      wxts: "الرجاء ملاحظة:" ,
      cont: "قد تؤدي المراكز القريبة من سعر السوق إلى احتمال الفشل في إصدار أمر بسعر السوق , أو جني الأرباح / وقف الخسارة بنجاح بسبب تقلبات السوق الحادة ومشاكل أخرى." ,
      qr: "موافق"
    } ,
    bbjy: {
      mr: "شراء" ,
      mc: "بيع" ,
      mai: "شراء" ,
      sell: "بيع" ,
      xj: "الحد",
      sj: "السوق" ,
      pk: "موضع",
      jg: "السعر",
      sl: "الكمية",
      ss: "الكمية",
      mrl: "حجم الشراء" ,
      mcl: "حجم البيع" ,
      ky: "متاح" ,
      km: "متاح",
      ksell: "قابل للتسويق",
      jye: "Turnover",
      dqwt: "التفويض الحالي" ,
      lswt: "مهمة تاريخية" ,
      jj: "معلومات",
      wtzl: "إجمالي",
      wtjg: "سعر التوكيل" ,
      ycjl: "حجم التداول المكتمل",
      cjjj: "متوسط سعر المعاملة" ,
      cd: "سحب",
      xd: "ترتيب",
      wqcj: "صفقة كاملة" ,
      ywc: "مكتمل",
      ycd: "الطلب الملغي",
      zx: "المفضلة",
      scjg: "سعر السوق",
      fhsj: "تاريخ الإصدار" ,
      fhsl: "رقم الإصدار" ,
      bps: "مستند تقني" ,
      gw: "الموقع الرسمي",
      qx: "إلغاء"
    } ,
    "hyjy": {
      mai: "شراء" ,
      sell: "بيع" ,
    kc: "المراكز المفتوحة",
    pc: "إغلاق المراكز",
    cc: "المناصب",
    kp: "إغلاق",
    kpc: "إغلاق قصير",
    kcc: "المناصب",
    kkd: "فتح طويل",
    kpd: "إغلاق طويل",
    kkk: "فتح قصير",
    xj: "الحد",
    sj: "السوق" ,
    xjwt: "أمر محدد",
    sjwt: "سعر السوق" ,
    pk: "موضع",
    jg: "السعر",
    sl: "الكمية",
    gg: "ليفر",
    tzgg: "ذراع التحكم",
    ggbs: "الرافعة المالية",
    mrl: "حجم الشراء" ,
    ky: "متاح" ,
    jye: "Turnover",
    dqwt: "الصلاحيات الحالية",
    lswt: "مهمة تاريخية" ,
    ptwt: "تعهدات عادية" ,
    dqwtmr: "التوكيلات الحالية (شراء)" ,
    dqwtmc: "التوكيلات الحالية (بيع)" ,
    hywt: "تعهدات العقد" ,
    jj: "معلومات",
    wtzl: "إجمالي",
    wtjg: "سعر التوكيل" ,
    ycjl: "حجم التداول المكتمل",
    cjjj: "متوسط سعر المعاملة" ,
    qbcd: "سحب كافة الطلبات",
    cd: "سحب",
    xd: "ترتيب",
    wqcj: "صفقة كاملة" ,
    ywc: "مكتمل",
    ycd: "الطلب الملغي",
    zx: "المفضلة",
    scjg: "سعر السوق",
    fhsj: "تاريخ الإصدار" ,
    fhsl: "رقم الإصدار" ,
    bps: "مستند تقني" ,
    gw: "الموقع الرسمي",
    mrzd: "فتح لفترة طويلة" ,
    mrpk: "إغلاق قصير",
    mczk: "فتح قصير",
    mcpd: "إغلاق طويل",
    mrkdkz: "فتح طويل (صعودي)" ,
    mrpkkz: "إغلاق قصير (صعودي)" ,
    mckkkd: "فتح قصير (هبوطي)" ,
    mcpdkd: "إغلاق طويل (هبوطي)" ,
    yxhy: "عقد دائم",
    dc: "المناصب الطويلة",
    kcjj: "متوسط سعر المركز المفتوح (BUSDT)" ,
    wsxyl: "ربح غير محقق (BUSDT)" ,
    ygqpj: "تقدير التكافؤ القوي (BUSDT)" ,
    syl: "معدل العائد",
    cwbzj: "هامش المركز (BUSDT)" ,
    cw: "موضع (No.)",
    cwjz: "قيمة الموضع (BUSDT)" ,
    bzjl: "معدل الهامش",
    kpz: "إغلاق (رقم)" ,
    bdzs: "الفهرس الأساسي",
    "tzbzj": "ضبط الهامش",
    zyzs: "جني الأرباح ووقف الخسارة",
    zjbzj: "زيادة الهامش",
    jsbzj: "تقليل الهامش",
    tyhy: "عقد الخبرة" ,
    ccz: "Position (No.)",
    cwbzjt: "هامش المركز (TBTC)" ,
    zdzjbzj: "الحد الأقصى لزيادة الهامش (TBTC)" ,
    zjbzjt: "زيادة الهامش (TBTC)",
    zhang: "الكمية",
    qblx: "جميع الأنواع",
    qb: "الكل",
    ccjg: "سعر المركز",
    ccsl: "عدد المناصب",
    yk: "الربح والخسارة" ,
    ccsj: "وقت المناصب",
    zy: "جني الأرباح" ,
    zs: "وقف الخسارة",
    zje: "المبلغ الإجمالي" ,
    kcs: "عدد الصفقات المفتوحة",
    kcjg: "سعر المراكز المفتوحة",
    ss: "الكثير",
    hand: "1 لوت = ",
    qx: "إلغاء",
    qr: "موافق"
    } ,
    kxt: {
      gao: "H",
      di: "L",
      wtgd: "ترتيب",
      cj: "صفقة" ,
      jj: "معلومات",
      sj: "الوقت",
      fx: "الاتجاه",
      jg: "السعر",
      sl: "الكمية",
      mr: "شراء" ,
      mc: "بيع" ,
      mp: "مُنَاقَصَة",
      sp: "بيع",
      slb: "الكمية",
      fhsj: "تاريخ الإصدار" ,
      fhsl: "رقم الإصدار" ,
      bps: "مستند تقني" ,
      gw: "الموقع الرسمي",
      "fz":"min",
      "xs":"hour",
      "tian":"day",
      "zhou":"week",
      "yue":"month",
      "gd":"More",
      ft: "رسم بياني" ,
      zt: "الرسم البياني الرئيسي",
      sdt: "عمق الصورة" ,
      zx: "المفضلة",
      djck: "انقر للعرض"
    } ,
    zhjl: {
      cbtb: "إيداع وسحب",
      jymx: "تفاصيل المعاملة",
      tgyj: "لجنة الترويج" ,
      wwc: "تم التراجع عنه",
      ywc: "مكتمل"
    } ,
    zwsj: {
      title: "لا يوجد سجل"
    } ,
    bzxz: {
      title: "رمز مميز"
    } ,
    "jghy": {
    jghy: "العقود الآجلة",
    yxhy: "دائم الازهار",
    mz: "صاعد",
    md: "سبحة",
    gmj: "سعر الشراء" ,
    jsj: "سعر التسوية" ,
    xj: "السعر الحالي",
    fx: "الاتجاه",
    sl: "الحجم",
    jgsj: "وقت التسليم" ,
    gb: "إغلاق",
    jxxd: "متابعة تقديم طلب" ,
    cclb: "قائمة الطلبات",
    zc: "الحالي",
    lscc: "تاريخ",
    qblx: "الكل",
    yk: "ربح",
    ddqr: "تأكيد الطلب",
    dqsj: "وقت انتهاء الصلاحية",
    jssj: "وقت التسليم" ,
    sy: "الربح" ,
    tzje: "سعر الاستثمار" ,
    zdje: "أقل سعر 0",
    kyye: "توازن:",
    kyye2: "توازن",
    sxf: "الرسوم:" ,
    sxfl: "الرسوم" ,
    jypz: "الاسم",
    jyfx: "الاتجاه",
    qrxd: "تأكيد" ,
    fs: "Line",
    dqye: "الرصيد الحالي"
    } ,
    kjmb: {
      title: "عملة مشفرة",
      gm: "شراء USDT",
      wxts: "تذكير:" ,
      "wxts-copy": "يُرجى نسخ عنوان usdt. تحتاج إلى استخدام هذا العنوان لشراء usdt." ,
      copy: "نسخ",
      ljmb: "شراء عملة مشفرة",
      buy: "اشتر",
      cs: "بيع" ,
      qx: "إلغاء",
      gmsl: "مبلغ الشراء" ,
      cssl: "المبلغ المباع" ,
      qsrgmsl: "الرجاء إدخال مبلغ الشراء" ,
      qsrcssl: "الرجاء إدخال مبلغ البيع" ,
      qxzzffs: "الرجاء تحديد طريقة الدفع",
      yhk: "بطاقة مصرفية",
      wx: "Wechat",
      zfb: "Alipay",
      jg: "السعر",
      kyye: "توازن",
      zxjysl: "الحد الأدنى لعدد المعاملات" ,
      ts1: "1.جميع التجار الذين يشترون ويبيعون هم تجار معتمدين على النظام الأساسي ويقدمون خدمة على مدار 24 ساعة.",
      ts2: "2.إذا كان هناك نزاع حول الطلب , فيرجى الاتصال بخدمة العملاء على الفور للتعامل معها.",
      fzcg: "نسخ ناجح"
    } ,
    "tips":{
      jymm: "كلمة مرور المعاملة",
      szjymm: "تعيين كلمة مرور المعاملة" ,
      qsrjymm: "أدخل كلمة مرور المعاملة" ,
      jymmts: "الرجاء الانتقال إلى مركز الأمان لتعيين كلمة مرور المعاملة"
    } ,
    xyf: {
      title: "درجة الائتمان",
      pgsj: "وقت التقييم"
    } ,
    dzrz: {
      title: "مصادقة العنوان",
      sdddz: "عنوان فاتورة خدمات",
      tpsc: "تحميل صورة الفاتورة",
      ts: "تذكير: تحتاج إلى ملء معلومات العنوان وإرسال فاتورة المرافق أو فاتورة عنوان النطاق العريض" ,
      tips: "تحتاج إلى ملء معلومات العنوان وإرسال فاتورة المرافق أو فاتورة عنوان النطاق العريض" ,
      qsczdtp: "الرجاء تحميل صورة الفاتورة"
    } ,
    newReg: {
      sjh: "متحرك",
      yx: "البريد الإلكتروني" ,
      yqm: "رمز الدعوة" ,
      yqm2: "رمز الدعوة (اختياري)" ,
      cjzh: "إنشاء حساب" ,
      sysjhzyx: "التسجيل برقم الجوال / البريد الإلكتروني",
      sj: "الجوال",
      yhxy: "اتفاقية المستخدم",
      yhxy2: 'لقد قرأت ووافقت على "اتفاقية المستخدم"'
    } ,
    mbwt: {
      title: "مشكلات الأمان",
      mbwt: "مشكلات الأمان",
      qtxda: "الرجاء ملء الإجابة",
      qsrxmm: "الرجاء إدخال كلمة مرور جديدة" ,
      sydqmmcz: "استخدم إعادة تعيين كلمة المرور الحالية",
      zhmm: "مشكلات الأمان , استرداد كلمة المرور",
      ysz: "تم تعيينه" ,
      tg: "تجاهل",
      tj: "إرسال" ,
      zyts: "هام:" ,
      zytsCont: "لا تفصح عن الإجابة السرية ورمز التحقق , وتذكر مشكلة الأمان , والتي ستساعدك على استرداد كلمة المرور الخاصة بك"
    } ,
    xbsg: {
      title: "منطقة العملات الجديدة" ,
      wdsg: "التفاصيل",
      scts: "أيام الحجز:",
      sy: "المتبقية",
      ljsg: "اشترك الآن",
      ysk: "نفدت الكمية" ,
      xzjdy: "اشترك الآن",
      dy: "اشتراك" ,
      fxjg: "سعر الإصدار",
      fxl: "التداول" ,
      ssrq: "تاريخ الإدراج",
      yxqx: "فترة الصلاحية",
      qsrsl: "الرجاء إدخال المبلغ",
      syl: "المتبقية",
      sgrq: "اشتراك",
      sgsl: "المبلغ",
      bz: "عملة",
      yebz: "رصيد USDT غير كافٍ" ,
      tgsl: "تمرير الكمية",
      shz: "قيد المراجعة",
      wtg: "لم تمر" ,
      ytg: "تم اجتيازه"
    } ,
    wydb: {
      title: "استعارة",
      db: "استعارة",
      dbz: "استعارة",
      jl: "سجل",
      jdzq: "الفترة (أيام)",
      qhk: "للسداد" ,
      ljdb: "تراكمي (usdt)" ,
      dhkbs: "الدفع المعلق",
      jkje: "مبلغ القرض (دولار أمريكي)" ,
      qsrje: "الرجاء إدخال المبلغ" ,
      rll: "سعر الفائدة اليومي",
      hkfs: "السداد",
      dqych: "منتهية الصلاحية",
      lx: "الفائدة",
      fkjg: "المُقرض" ,
      tpsc: "قرض ائتماني (تحميل صورة)",
      fwxx: "معلومات السكن" ,
      srzm: "إثبات الدخل (علاقة العمل)" ,
      yhmx: "كشف حساب بنكي",
      zjz: "صورة الهوية" ,
      yd: "لقد قرأت ووافقت" ,
      xy: "التقدم بطلب للحصول على اتفاقية قرض" ,
      sqdb: "انقر لتقديم طلب للحصول على سلاسل القروض",
      gb: "إغلاق",
      qd: "موافق",
      ts: "الرجاء تحديد التقدم بطلب للحصول على اتفاقية قرض" ,
      dbjl: "سجل",
      hkhth: "كود الطلب" ,
      wsh: "لم تتم مراجعته",
      yfk: "قرض",
      sqrq: "وقت التطبيق",
      zq: "دورة",
      dbsl: "عدد الأضلاع",
      zhke: "إجمالي الدفع" ,
      yhkxq: "تفاصيل السداد",
      bqyhk: "قابل للسداد في الفترة الحالية (USDT)" ,
      hktips: "الرجاء التأكد من أن الرصيد كافٍ , إذا كان الرصيد غير كاف , يرجى إعادة الشحن أولاً ثم السداد ",
      bj: "الرئيسي",
      jie: "استعارة",
      ljhk: "سداد فوري",
      qcz: "للإيداع",
      yebzqxcz: "رصيد غير كاف , يرجى إعادة الشحن أولاً ثم السداد" ,
      znj: "رسوم السداد المتأخر" ,
      yqts: "الأيام المتأخرة"
    } ,
    hkxq: {
      dd: "طلب",
      fzhkdz: "انسخ عنوان السداد" ,
      hkxq: "تفاصيل السداد",
      zlx: "إجمالي الفائدة",
      zhk: "إجمالي السداد" ,
      hkjg: "وكالة السداد",
      qschkpz: "الرجاء تحميل شهادة السداد" ,
      hkpz: "شهادة السداد"
    } ,
    bbjyNew: {
      jylx: "أنواع",
      jyze: "المبلغ"
    } ,
    "indexNew": {
      title: "إضافة رمز مميز إلى الواجهة الرئيسية" ,
      t1: "وصول سريع إلى تجربة ملء الشاشة",
      t2: "انقر على شريط الأدوات أدناه" ,
      t3: "وحدد" ,
      t4: "إضافة إلى الشاشة الرئيسية",
      t5: "إضافة إلى الإصدار الكامل لتجربة سطح المكتب من Spmaxex" ,
      t6: "إضافة إلى المفضلة",
      t7: "بحث في الصفحة"
    } ,
    "bind":{
      title: "مصادقة البريد الإلكتروني",
      ybd: "منضم",
      wbd: "غير منضم",
      yrz: "تم التحقق منه" ,
      wrz: "لم يتم التحقق منه",
      ts: "لحماية حسابك , يوصى بربط عنوان بريد إلكتروني" ,
      qsryxdz: "عنوان البريد الإلكتروني"
    } ,
    "status":{
      statusText: ["فشل" , "قيد المراجعة" , "نجاح"],
    } ,
    "tipsNew": {
      wjmmts: "استرداد كلمة المرور برمز التحقق",
      qscpztp: "الرجاء تحميل صورة القسيمة" ,
      emailgsts: "علب بريد الإدخال لا تتوافق مع القواعد" ,
      telgsts: "رقم الهاتف الجوال غير صحيح" ,
      lcmmbyz: "الرجاء تأكيد كلمة المرور الخاصة بك",
      zdsl: "الحد الأدنى للكمية",
      sldydy: "كمية أكبر من أو تساوي" ,
      zxtzsl: "الحد الأدنى للكمية",
      ddz: "انتظار",
      xs: "ساعة",
      min: "الحد الأدنى للمبلغ",
      max: "الحد الأقصى للمبلغ" ,
      yebz: "رصيد غير كافٍ",
      qsrss: "الرجاء إدخال القرعة",
      zdss: "الحد الأدنى من اللوت",
      yjj: "مرفوض" ,
      shz: "الفداء",
      zwkfcz: "هذه العملة غير مفتوحة للإيداع" ,
      jiaoge: "التسليم",
      zhang: "الارتفاع" ,
      die: "سقوط" ,
      cjxnzh: "إنشاء حساب افتراضي",
      "yhzz": " الدولار الأمريكي (التحويل البنكي)"
  },
  "langNew2":{
    "flzq": "مركز المكافآت",
    "qdjl": "مكافأة تسجيل الدخول",
    "mrqdjl": "مكافأة تسجيل الدخول اليومية",
    "qd": "تسجيل الدخول",
    "yqd": "تم الدخول",
    "hdgz": "قواعد الحدث",
    "qdjl2": "تسجيل الوصول",
    "qdcg": "تسجيل الدخول بنجاح",
    "yhd": "مكتسبة",
    "lq": "تلقي",
    "dyt": "اليوم الأول",
    "det": "اليوم التالي",
    "dst": "اليوم الثالث",
    "dsit": "اليوم الرابع",
    "dwt": "اليوم الخامس",
    "dlt": "اليوم السادس",
    "dqt": "اليوم السابع",
    "jxz": "قيد التقدم"
  },
  "langNew":{
    "kp": "افتتاح",
    "zuoshou": "استقبل أمس",
    "zg": "الأعلى",
    "zd": "أدنى",
    "dqjg": "السعر الحالي",
    "pcjg": "سعر نهائي",
    "gd": "طلب معلق",
    "gdj": "سعر الأمر المعلق",
    "gdjg": "سعر الأمر المعلق",
    "xfbzj": "إيداع الضمان المطلوب: ",
    "ksrfw": "نطاق الإدخال المتاح: ",
    "shou": "الكثير",
    "fdjyk": "عائم صافي الربح والخسارة",
    "pcsl": "كمية الإغلاق",
    "cx": "سحب او إبطال",
    "qrpc": "أكد لإغلاق المركز",
    "sx": "منقي",
    "cz": "إعادة ضبط",
    "zdl": "عرف",
    "kccg": "تم فتح مركز بنجاح!",
    "xzfx": "اختر الاتجاه",
    "lx": "يكتب",
    "xgcc": "تعديل الموقف",
    "szzyzs": "تعيين وقف الربح ووقف الخسارة",
    "szhb": "عملة مشفرة",
    "gjs": "معدن",
    "yy": "خام",
    "jy": "تجارة",
    "jmhb": "عملة مشفرة",
    "gdsj": "وقت الطلب المعلق",
    "gdsl": "كمية الطلب المعلقة",
    "fs": "time",
    "qbdl": "تسجيل الدخول إلى المحفظة",
    "qbdlts": "يرجى استخدام متصفح المحفظة للوصول وتسجيل الدخول",
    "tcmnzh": "تسجيل الخروج من الحساب الافتراضي",
    "bc": "موقف الغطاء",
    "qdlzszh":"يرجى تسجيل الدخول إلى حسابك الحقيقي لإعادة الشحن",
    "ts": "اِسْتَدْعَى",
    "czsqytj": "تم تقديم طلب إعادة الشحن",
    "czdzts": "تم تقديم طلب الشحن ولم يتم استلام الشحنة؟",
    "fhsy": "العوده للصفحة الرئيسية",
    "je": "كمية",
    "zdje": "الحد الأدنى للمبلغ ",
    "zdje2": "الحد الأقصى للمبلغ "
   }
}





// WEBPACK FOOTER //
// ./src/utils/lang/alb.js